import { RootState } from 'typesafe-actions'

import { PASSWORD_CHANGE_IN_PROGRESS_OPERATION_ID } from '../../Constants/PasswordChangeConstants'
import { selectIsAsyncOperationIsInProgress } from '../../../../../async-operation'

export const selectIsPasswordChangeInProgress = (state: RootState): boolean => {
    return selectIsAsyncOperationIsInProgress(state, PASSWORD_CHANGE_IN_PROGRESS_OPERATION_ID)
}
